<template>
  <header class="cm-header" :class="{ scrolled: isScrolled }">

    <div class="cm-top-banner">
      <div class="cm-banner-track">
        <span>Envios a todo USA x $15 USD</span>
         <span>Envios a todo USA x $15  USD</span>
        <span>En compras mayores de $199 USD envío gratis</span>
         <span>En compras mayores de $199 USD envío gratis</span>
      </div>
    </div>

    <div class="cm-top">
      <div class="cm-left-actions mobile-only">
        <button class="cm-icon-btn" @click.stop="togglePasillosMobile">☰</button>
      </div>

      <div class="cm-brand" @click="goHome">
        <img src="@/assets/logo2.png" class="cm-logo" alt="Logo" />
      </div>

      <div class="cm-search-container desktop-only">
        <div class="cm-search-wrapper">
          <input
            v-model="searchQuery"
            class="cm-search-input"
            placeholder="Buscar productos religiosos..."
            @keyup.enter="submitSearch"
          />
          <button class="cm-search-btn" @click="submitSearch">
            <img src="@/assets/search.png" alt="Buscar" />
          </button>
        </div>
      </div>

      <nav class="cm-actions desktop-only">
        <button class="cm-delivery-pill" @click="openStoreModal">
          <img src="@/assets/ubicacion.png" class="icon-dark" />
          <span>{{ selectedStoreName }}</span>
        </button>

        <button v-if="!loggedIn" class="cm-nav-btn" @click="goToAccount">
          Iniciar sesión
        </button>

        <button class="cm-cart-black" @click="openCartSidebar">
          <span class="cart-icon">🛒</span>
          <span class="cart-badge" v-if="cartItems > 0">{{ cartItems }}</span>
          <span class="cart-total">${{ cartTotalFormatted }}</span>
        </button>
      </nav>

      <div class="cm-right-mobile mobile-only">
        <button class="cm-icon-btn black-text" @click="openCartSidebar">
          <span class="cart-icon">🛒</span>
          <span class="cart-badge" v-if="cartItems > 0">{{ cartItems }}</span>
        </button>
      </div>
    </div>

    <div class="cm-search-section mobile-only">
      <div class="cm-search-wrapper">
        <input
          v-model="searchQuery"
          class="cm-search-input"
          placeholder="Buscar productos religiosos..."
          @keyup.enter="submitSearch"
        />
        <button class="cm-search-btn" @click="submitSearch">
          <img src="@/assets/search.png" alt="Buscar" />
        </button>
      </div>
    </div>

    <div class="cm-mobile-location-bar mobile-only" @click="openStoreModal">
      <img src="@/assets/ubicacion.png" class="icon-white" />
      <span>{{ selectedStoreName }}</span>
    </div>

    <nav class="cm-navbar desktop-only">
      <ul class="cm-nav-list">
        <li
          v-for="cat in categoriasConHijas"
          :key="cat.id"
          class="cm-nav-item"
          @mouseenter="cat.open = true"
          @mouseleave="cat.open = false"
        >
          <span
            class="cm-nav-link"
            @click="$router.push({ name:'departamento-vista', params:{ handle: cat.handle } })"
          >
            {{ cat.title }}
          </span>

          <transition name="fade">
            <ul v-if="cat.open && cat.subcategorias.length" class="cm-dropdown">
              <li
                v-for="sub in cat.subcategorias"
                :key="sub.id"
                @click="selectSubcategory(sub)"
              >
                {{ sub.title }}
              </li>
            </ul>
          </transition>
        </li>
        <li class="cm-nav-item music-highlight" @click="goToMusic">
          <span class="cm-nav-link gold-text">Jesús Cavazos Music</span>
          
        </li>
        <li class="cm-nav-item trayectory-highlight" @click="goToTrayectoria">
  <span class="cm-nav-link gold-text">Trayectoria</span>
</li>
      </ul>
    </nav>

    <transition name="slide">
      <div v-if="pasillosMobileOpen" class="cm-sidebar">
        <div class="sidebar-header">
          <img src="@/assets/logo2.png" class="sidebar-logo" />
          <button class="close-sidebar" @click="togglePasillosMobile">✕</button>
        </div>
        <ul class="sidebar-list">
          <li v-for="cat in categoriasConHijas" :key="'m'+cat.id">
            <div class="sidebar-item">
              <span class="sidebar-title" @click="goToDepartamento(cat)">
                {{ cat.title }}
              </span>
              <span class="arrow" @click.stop="toggleMobileCat(cat)">
                <i :class="cat.open ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
              </span>
            </div>
            <ul v-if="cat.open" class="sidebar-sub">
              <li
                v-for="sub in cat.subcategorias"
                :key="'s'+sub.id"
                @click="selectSubcategory(sub)"
              >
                {{ sub.title }}
              </li>
            </ul>
          </li>

          <li class="sidebar-divider"></li>
          <li class="sidebar-music-item" @click="goToMusic">
            <div class="sidebar-item no-border">
              <span class="sidebar-title gold-text"> Jesús Cavazos Music</span>
              <span class="arrow"><i class="fas fa-chevron-right gold-text"></i></span>
            </div>
          </li><li class="sidebar-trayectory-item" @click="goToTrayectoria">
  <div class="sidebar-item no-border pt-0">
    <span class="sidebar-title gold-text small-gold">Trayectoria</span>
  </div>
</li>
        </ul>
      </div>
    </transition>

    <div v-if="pasillosMobileOpen" class="overlay" @click="togglePasillosMobile"></div>

  </header>
</template>
<script>
import { eventBus } from "@/eventBus";
import axios from "axios";
import baseUrl from "@/api";
import { useLocationStore } from "@/stores/location";

export default {
  name: "HeaderColonialMarket",
  data() {
    return {
      categoriasConHijas: [],
      cartItems: 0,
      cartTotal: 0,
      searchQuery: "",
      isScrolled: false,
      pasillosMobileOpen: false,
      loggedIn: false,
      customerName: "",
    };
  },
  computed: {
    locationStore() { return useLocationStore(); },
    selectedStoreName() { return this.locationStore.selectedStore?.name || "Seleccionar sucursal"; },
    cartTotalFormatted() { return Number(this.cartTotal || 0).toFixed(2); },
  },
  methods: {goToTrayectoria() {
    this.$router.push({ name: 'trayectoria-jesus-cavazos' }); // O el nombre de tu ruta de trayectoria
    this.pasillosMobileOpen = false;
  },
    goToMusic() {
    this.$router.push({ name: 'discografia-jesus-cavazos' }); // Asegúrate de que el nombre coincida con tu router
    this.pasillosMobileOpen = false;
  },
goToDepartamento(cat) {
  this.$router.push({
    name: "departamento-vista",
    params: {
      handle: cat.handle
    }
  });

  this.pasillosMobileOpen = false;
}

 ,
    async cargarCategorias() {
  try {
    const res = await axios.get(`${baseUrl}/shopify/categories`);
    const categorias = res.data.categorias || [];

    // 🔥 usar directamente las colecciones manuales
    this.categoriasConHijas = categorias.map(cat => ({
      ...cat,
      open: false
    }));

  } catch (e) {
    console.error("Error API:", e);
  }
},
    cargarCarrito() {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      this.cartItems = cart.reduce((sum, p) => sum + p.qty, 0);
      this.cartTotal = cart.reduce((sum, p) => sum + (p.qty * p.price), 0);
    },
    togglePasillosMobile() { this.pasillosMobileOpen = !this.pasillosMobileOpen; },
    toggleMobileCat(cat) { cat.open = !cat.open; },
   selectSubcategory(sub) {
  this.$router.push({
    name: "categoria-vista",
    params: {
      handle: sub.handle || sub.title.toLowerCase().replace(/\s+/g, "-")
    }
  });

  this.pasillosMobileOpen = false;
},
    goHome() { this.$router.push("/"); },
    submitSearch() {
      if (!this.searchQuery.trim()) return;
      this.$router.push({ name: "busqueda", query: { q: this.searchQuery.trim() } });
    },
    openStoreModal() { this.locationStore.openModal(); },
    openCartSidebar() { if (eventBus.openCart) eventBus.openCart(); },
    handleScroll() { this.isScrolled = window.scrollY > 30; }
  }
  ,
  
  async mounted() {
    window.addEventListener("scroll", this.handleScroll);
    await this.cargarCategorias();
    this.cargarCarrito();
    this.$watch(() => eventBus.cartUpdated, () => this.cargarCarrito());
  },
  beforeUnmount() { window.removeEventListener("scroll", this.handleScroll); }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');

.cm-header {
  font-family: 'Poppins', sans-serif;
  --font-main: 'Inter', sans-serif;
  position: fixed;
  top: 0; left: 0; width: 100%;
  z-index: 1000;
  background: #ffffff;
  transition: all 0.3s ease;
}

/* BARRA SUPERIOR */
.cm-top-banner {
  width: 100%;
  background: #000;
  color: #fff;
  overflow: hidden;
  height: 34px;
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cm-banner-track {
  display: flex;
  gap: 80px;
  white-space: nowrap;
  animation: scrollBanner 25s linear infinite;
}

@keyframes scrollBanner {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.cm-header.scrolled {
  box-shadow: 0 2px 15px rgba(0,0,0,0.1);
}

.cm-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  height: 70px;
  background: #fff;
  gap: 30px;
}

.cm-brand { cursor: pointer; flex-shrink: 0; }
.cm-logo { height: 90px; width: auto; }

.cm-search-container { flex: 1; max-width: 600px; }
.cm-search-wrapper {
  width: 100%;
  display: flex;
  background: #f8f8f8;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.cm-search-input {
  flex: 1; border: none; padding: 10px 15px; outline: none;
  font-size: 0.9rem; background: transparent;
}

.cm-search-btn { background: #f0f0f0; border: none; padding: 0 15px; cursor: pointer; }

.cm-actions { display: flex; align-items: center; gap: 15px; flex-shrink: 0; }

.cm-delivery-pill {
  background: #fff; border: 1px solid #e0e0e0; color: #333;
  padding: 8px 12px; border-radius: 4px; font-size: 0.75rem;
  font-weight: 600; display: flex; align-items: center; gap: 8px; cursor: pointer;
}

.cm-nav-btn { background: transparent; border: none; color: #333; font-size: 0.8rem; font-weight: 500; cursor: pointer; }

.cm-cart-black {
  background: #000; color: #fff; border: none; padding: 8px 18px;
  border-radius: 4px; font-weight: 700; display: flex; align-items: center; gap: 10px; cursor: pointer;
}

.cm-navbar { background: #000; }
.cm-nav-list { display: flex; justify-content: center; list-style: none; margin: 0; padding: 0; }
.cm-nav-item { position: relative; padding: 12px 30px; }
.cm-nav-link { color: #fff; text-transform: uppercase; font-size: 0.75rem; font-weight: 700; letter-spacing: 1px; cursor: pointer; }

.cm-dropdown {
  position: absolute; top: 100%; left: 0; background: #ffffff;
  min-width: 240px; list-style: none; padding: 10px 0; border: 1px solid #eee;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.cm-dropdown li { padding: 12px 20px; color: #333; font-size: 0.85rem; font-weight: 500; cursor: pointer; }
.cm-dropdown li:hover { background: #f8f8f8; color: #000; }

/* MOBILE */
.mobile-only { display: none; }

@media (max-width: 1024px) {
  .mobile-only { display: block; }
  .desktop-only { display: none; }

  .cm-top { height: 75px; justify-content: space-between; padding: 0 15px; }
  .cm-brand { position: absolute; left: 50%; transform: translateX(-50%); }
  .cm-logo { height: 65px; }

  .cm-search-section { padding: 10px 15px; background: #fff; border-bottom: 1px solid #eee; }
  .cm-icon-btn { background: transparent; border: none; color: #000; font-size: 1.8rem; cursor: pointer; }

  .cm-mobile-location-bar {
    background: #000; color: #fff; text-align: center; padding: 10px;
    font-size: 0.8rem; font-weight: 700; display: flex; justify-content: center; align-items: center; gap: 8px;
  }
}

/* SIDEBAR MOBILE ESTILOS */
.cm-sidebar {
  position: fixed; top: 0; left: 0; width: 310px; height: 100%;
  background: #fff; z-index: 1100; padding: 25px;
  box-shadow: 10px 0 30px rgba(0,0,0,0.1);
}

.sidebar-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
.sidebar-logo { height: 40px; }
.close-sidebar { background: transparent; border: none; font-size: 1.5rem; cursor: pointer; }

.sidebar-list { list-style: none; padding: 0; }
.sidebar-item {
  padding: 15px 0; border-bottom: 1px solid #eee;
  font-weight: 600; color: #333; display: flex; justify-content: space-between;
  font-size: 0.9rem; text-transform: uppercase;
}

.sidebar-sub { list-style: none; padding-left: 15px; background: #f9f9f9; }
.sidebar-sub li { padding: 12px 0; font-size: 0.85rem; color: #666; border-bottom: 1px solid #f0f0f0; }

.overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1050; }

/* TRANSICIONES */
.slide-enter-active, .slide-leave-active { transition: transform 0.3s ease; }
.slide-enter-from, .slide-leave-to { transform: translateX(-100%); }

.icon-dark { filter: brightness(0); width: 14px; }
.icon-white { filter: brightness(0) invert(1); width: 14px; }
/* --- ESTILO MÚSICO MODERNO --- */

/* Línea divisoria: Ahora es una separación real y moderna */
.sidebar-divider {
  height: 2px;
  background: #f0f0f0; /* Un gris claro sólido pero fino */
  margin: 30px 10px 10px 10px;
  list-style: none;
  position: relative;
}

/* Item de música en móvil: Con fondo sutil para que parezca un botón premium */
.sidebar-music-item {
  cursor: pointer;
  margin: 10px;
  border-radius: 8px;
  background: #fcfaf5; /* Un crema casi blanco muy elegante */
  transition: all 0.3s ease;
}

.sidebar-music-item .sidebar-title {
  font-weight: 700 !important;
  letter-spacing: 1px;
}

/* Color Dorado Jesús Cavazos (Más vibrante) */
.gold-text { 
  color: #b1914d !important; 
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Desktop: Efecto de subrayado moderno */
.music-highlight .cm-nav-link {
  color: #b1914d !important;
  position: relative;
  font-weight: 800;
}

.music-highlight .cm-nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -4px;
  left: 0;
  background-color: #b1914d;
  transition: width 0.3s ease;
}

.music-highlight:hover .cm-nav-link::after {
  width: 100%;
}

.no-border {
  border: none !important;
  padding: 20px !important; /* Más espacio para que se vea importante */
}
/* Estilo para Trayectoria en Desktop */
.trayectory-highlight .cm-nav-link {
  color: #b1914d !important;
  font-weight: 500; /* Un poco más ligero que el nombre del artista */
  font-size: 0.85rem !important;
  letter-spacing: 2px;
  opacity: 0.9;
}

/* Estilo para Trayectoria en Móvil */
.sidebar-trayectory-item {
  cursor: pointer;
  margin: -5px 10px 10px 10px; /* Pegado al item de arriba */
  border-radius: 0 0 8px 8px;
  background: #fcfaf5;
  transition: all 0.3s ease;
}

.small-gold {
  font-size: 0.85rem !important;
  letter-spacing: 2px;
  font-weight: 500 !important;
}

.pt-0 {
  padding-top: 0 !important;
  margin-top: -10px;
}

/* Animación de hover para Trayectoria */
.trayectory-highlight:hover .cm-nav-link {
  opacity: 1;
  text-shadow: 0 0 8px rgba(177, 145, 77, 0.2);
}
</style>